// Suggestions (chips) handling

import { getAuthHeaders, authenticatedFetch } from '../api/auth.js';
import { getResearchPersistedOutputHtml } from './messages.js';
import { clearActiveResearchIdOnServer, setCurrentResearchId as _setCurrentResearchId, getCurrentResearchId } from '../state/research.js';

// Function to fetch and display suggested chips
export async function fetchSuggestions(query, timestamp, searchResultWrapper) {
    try {
        const response = await fetch(`/suggestions?query=${encodeURIComponent(query)}`, {
            headers: getAuthHeaders()
        });
        const data = await response.json();
        
        // Always create suggested chips container with new search button
        // Even if there are no suggestions, we still need the new search button
        const suggestions = data.suggestions && data.suggestions.length > 0 ? data.suggestions : [];
        createSuggestedChips(suggestions, timestamp, searchResultWrapper);
    } catch (error) {
        console.error('Error fetching suggestions:', error);
        // Even on error, create the container with just the new search button
        createSuggestedChips([], timestamp, searchResultWrapper);
    }
}

// Function to create suggested chips
export function createSuggestedChips(suggestions, timestamp, searchResultWrapper) {
    const container = document.querySelector('.container');
    
    // Hide all existing new-search-button-containers (from previous responses)
    const existingNewSearchButtons = container.querySelectorAll('.new-search-button-container');
    existingNewSearchButtons.forEach(btn => {
        btn.style.display = 'none';
    });
    
    // Create suggested chips container
    const suggestedChipsContainer = document.createElement('div');
    suggestedChipsContainer.id = `suggested-chips-${timestamp}`;
    suggestedChipsContainer.className = 'suggested-chips-container';
    
    // Create title (only show if there are suggestions)
    if (suggestions.length > 0) {
        const title = document.createElement('div');
        title.className = 'suggested-chips-title';
        title.textContent = 'Try below variations OR edit your query above';
        suggestedChipsContainer.appendChild(title);
    }
    
    // Create chips wrapper
    const chipsWrapper = document.createElement('div');
    chipsWrapper.className = 'suggested-chips-wrapper';
    
    // Create chips (only if there are suggestions)
    if (suggestions.length > 0) {
        suggestions.forEach(suggestion => {
            const chip = document.createElement('button');
            chip.className = 'chip suggested-chip';
            chip.textContent = suggestion;
            chip.setAttribute('data-value', suggestion);
            chip.addEventListener('click', async () => {
                const allowed = window.bms?.checkSearchLimit ? await window.bms.checkSearchLimit() : true;
                if (!allowed) return;
                document.getElementById('searchInput').value = suggestion;
                if (window.bms && window.bms.handleSearch) {
                    window.bms.handleSearch(true);
                }
            });
            chipsWrapper.appendChild(chip);
        });
        suggestedChipsContainer.appendChild(chipsWrapper);
    }
    
    // Create new search button
    const newSearchButtonContainer = document.createElement('div');
    newSearchButtonContainer.className = 'new-search-button-container';
    
    const newSearchButton = document.createElement('button');
    newSearchButton.className = 'new-search-button';
    newSearchButton.innerHTML = '<span class="material-symbols-rounded notranslate">add</span> New Research';
    newSearchButton.addEventListener('click', async () => {
        // Save response_html for this search before navigating (user may have clicked before the delayed save ran)
        const currentResearchId = getCurrentResearchId();
        const responseBodyWrapper = document.getElementById(`response-body-wrapper-${timestamp}`);
        const searchId = responseBodyWrapper?.getAttribute('data-search-id');
        const outputElement = document.getElementById(`output-${timestamp}`);
        if (currentResearchId && searchId && outputElement) {
            const responseHtml = getResearchPersistedOutputHtml(timestamp, outputElement);
            if (responseHtml && responseHtml.length > 0) {
                try {
                    await authenticatedFetch('/update-search-response', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
                        body: JSON.stringify({ research_id: currentResearchId, search_id: searchId, response_html: responseHtml })
                    });
                } catch (e) {
                    console.warn('[Research] Failed to save response_html before navigate:', e);
                }
            }
        }
        // Clear local session state so a new research session is created automatically
        await clearActiveResearchIdOnServer();
        _setCurrentResearchId(null);
        sessionStorage.removeItem('bms_session_id');
        sessionStorage.removeItem('bms_has_searched');
        // Navigate to root
        window.location.href = '/';
    });
    
    newSearchButtonContainer.appendChild(newSearchButton);
    suggestedChipsContainer.appendChild(newSearchButtonContainer);
    
    // Append to searchResultWrapper if provided, otherwise to container
    if (searchResultWrapper) {
        searchResultWrapper.appendChild(suggestedChipsContainer);
    } else {
        container.appendChild(suggestedChipsContainer);
    }
}
